export interface UnitPriceYears {
  value: number;
  label: string;
}

export type UnitPriceYearsGerResponse = UnitPriceYears[];

export const EmptyUnitPriceYearsGetResponse: UnitPriceYearsGerResponse = [
  {
    value: 0,
    label: '',
  },
];
